
<template>
    <div>
         <div class="person-verift" v-show="show">
             <!-- 消息标题 -->
              <div class="person-verift-title" >您扫描的二维码为授权员工</div>
              <div class="person-verift-contet clearfix">
                <div class="person-verift-info">
                    <div>姓名：{{userInfo.name}} </div>
                    <div>联系方式：{{userInfo.phone}} </div>
                    <div>职务：{{userInfo.duty}} </div>                        
              </div>
               <div class="person-verift-img">
                    <img :src="userInfo.headImage" alt="" srcset="">
               </div>
              </div>
         </div>
           <div class="person-verift" v-show="!show">
             <!-- 消息标题 -->
              <div class="person-verift-title">您扫描的二维码无授权结果</div>
            </div>
    </div>
</template>

<script>
import { qrcodeCheck } from "@/api/user";
export default {
    data() {
        return{
           show:true,
           userInfo:'' ,
        }
    },
    // created() {
    //     this.requestQrcodeCheck()
    // },
    mounted() {
        this.requestQrcodeCheck()
    },
    methods:{
        requestQrcodeCheck() {
            // console.log()
            let id = this.$route.query.getCode
            qrcodeCheck({id:id}).then(res=>{
                console.log(res.data)
                if(res.code == 200) {
                     this.userInfo = res.data
                }else{
                    this.show = false
                } 
            })
        }        
    }
    
}
</script>

<style scoped lang="scss">
    // 消息标题
    .person-verift-title {
        width: 100%;
        height:54px;
        line-height: 54px;
        text-align: left;
        padding: 0 13px;
        box-sizing: border-box;
        font-size: 15px;
        color: #333333;
    }
    // 内容
    .person-verift-contet {
        width: 350px;
        height: 114px;
        background-color: #eeeeee;
        border-radius: 5px;
        text-align: left;
        font-size: 14px;
        margin: 0 auto;
        padding: 20px 14px;
        box-sizing: border-box;
        .person-verift-info {
            float: left;
            div {
                margin-top: 15px;
                &:first-child {
                    margin-top: 0
                }
             }
        }
        .person-verift-img {
             width: 70px;
             height: 70px;
             float: right;
             img {
                 width: 70px;
                 height: 70px;
             }
        }
    }
</style>
